import React, { Fragment } from "react";
import profile from "../img/button/Account [BTN].png";
import back from "../img/button/Back [BTN].png";
import logout from "../img/button/LogOut.png";
import search from "../img/button/CERCA CHAT [BTN].png";
import plusBilancio from "../img/button/+ Risultati [BTN] (3).png";
import xBilancio from "../img/button/+ Risultati [BTN] (2).png";
//profilo
//back
//logout

const style = {
  height: 64,
  width: 64,
  objectFit: "fill",
  marginTop: 4,
  cursor: "pointer",
};
const style2 = {
  height: 37,
  width: 42,
  objectFit: "fill",
  marginTop: 4,
  cursor: "pointer",
};
const style3 = {
  height: 56,
  width: 56,
  objectFit: "fill",
  marginTop: 4,
  cursor: "pointer",
};
const style4 = {
  height: 72,
  width: 72,
  objectFit: "fill",
  marginTop: 4,
  cursor: "pointer",
};

class Button extends React.Component {
  render() {
    return (
      <Fragment>
        {this.props.scope == "profile" && (
          <img src={profile} alt="" style={style} onClick={this.props.goTo} />
        )}
        {this.props.scope == "back" && (
          <img src={back} alt="" style={style} onClick={this.props.goTo} />
        )}
        {this.props.scope == "logOut" && (
          <img src={logout} alt="" style={style} onClick={this.props.goTo} />
        )}
        {this.props.scope == "search" && (
          <img src={search} alt="" style={style2} onClick={this.props.goTo} />
        )}
        {this.props.scope == "plusBilancio" && (
          <img
            src={this.props.visualizzati >= this.props.arrayLength ? xBilancio : plusBilancio}
            alt=""
            style={this.props.visualizzati >= this.props.arrayLength ? style4 : style3}
            onClick={
              this.props.visualizzati >= this.props.arrayLength
                ? this.props.setDefault
                : this.props.goTo
            }
          />
        )}
      </Fragment>
    );
  }
}

export default Button;
